import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { TranslationService } from 'src/app/core/services/translation/translation.service';
import { ChipContent } from 'src/app/shared/models/chip-content/chip-content';
import { ChipContentOption } from 'src/app/shared/models/chip-content/chip-content-option';

@Component({
  selector: 'app-filter-area',
  templateUrl: './filter-area.component.html',
  styleUrls: ['./filter-area.component.scss'],
})
/**
 * Filter Area Organism
 */
export class FilterAreaComponent implements OnInit {
  @Input() isCarousel: boolean = true;
  @Input() chipContents!: ChipContent[];
  @Input() isGray: boolean = false;
  @Input() isGrayBlue: boolean = false;

  @Input() customOptions: OwlOptions = {
    loop: false,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    margin: 5,
    responsive: {
      0: {
        items: 3,
      },
      480: {
        items: 4,
      },
    },
    stagePadding: 20,
  };
  @Output() selectedFilter = new EventEmitter<any>();
  @Output() selectedOption = new EventEmitter<any>();

  /**
   * @constructor
   */
  constructor(private translationService: TranslationService) {}

  /**
   * ngOnInit()
   */
  ngOnInit(): void {
    this.translationService.translateChipContentArray(this.chipContents);
  }

  /**
   * Selects and emit the filter
   * @param {ChipContent} element
   */
  selectFilter(element: ChipContent) {
    this.selectedFilter.emit(element);
  }

  /**
   * Select chip option
   * @param {ChipContentOption} event
   * @param {ChipContent} element
   */
  selectChipOption(event: ChipContentOption, element: ChipContent) {
    element.value = event.text;
    this.selectedOption.emit(event);
  }
}
